<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="errorMessage" :mensagem="errorMessage" />

    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Nro OS</label>
                <div class="field-label field-label-end">{{ objEdicao.cdobraos }}</div>
            </div>

            <div class="form-item form-item-data">
                <label class="label-caption">Data</label>
                <input type="date" v-model="objEdicao.dtobraos" required />
            </div>

            <ObrasTpServicoSelect class="form-item" v-model:tpservicoSelecionado="objEdicao.idobratpservico" required />
        </div>

        <div class="row row-space">
            <BairroSelect class="form-item" v-model:bairroSelecionado="objEdicao.idbairro" required />

            <div class="form-item">
                <label class="label-caption">Logradouro</label>
                <input type="text" v-model="objEdicao.nmlogradouro" v-uppercase required maxlength="100" />
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Nro Endereço</label>
                <input type="text" class="input-right" v-model="edNmEndereco" v-number maxlength="5" />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Referência</label>
                <input type="text" v-model="objEdicao.referencia" v-uppercase required maxlength="100" />
            </div>

            <div class="form-item-coordenadas">
                <CoordenadasSelect v-model:modelValueLatitude="edLatitude" v-model:modelValueLongitude="edLongitude" />
            </div>
        </div>
        

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Detalhamento</label>
                <textarea v-model="objEdicao.detalhamento" maxlength="1000" rows="5" style="resize: none;"/>
            </div>
        </div>


        <div class="row-end">
            <button type="submit" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="cancel" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { criarObraOs } from '@/models/ObraOs';
import { Funcoes } from '@/funcoes/utils';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import BairroSelect from '@/selects/BairroSelect.vue';
import CoordenadasSelect from '@/components/CoordenadasSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import ObrasTpServicoSelect from '@/selects/ObrasTpServicoSelect.vue';

const emit = defineEmits(['close', 'salvo']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const edLatitude = ref(null);
const edLongitude = ref(null);
const edNmEndereco = ref(null);
const errorMessage = ref(null);
const objEdicao = criarObraOs();
const isLoading = ref(false);

const cancelForm = () => {emit('close');};

const lerDados = async() => {
    try{
        isLoading.value=true;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('obras_os', props.idEdicao);
                Object.assign(objEdicao, req[0]);
                edLatitude.value  = objEdicao.latitude;
                edLongitude.value = objEdicao.longitude;
            }catch (error){console.error('Erro leitura dos dados', error);}
        }else{
            objEdicao.idmunicipio = globalStore.idmunicipio;
        }
        objEdicao.idusuario = globalStore.idusuario;
        edNmEndereco.value  = Funcoes.formatInteger(objEdicao.nmendereco);
    }finally{isLoading.value=false;}
};

const salvarDados = async () => {
    try {
        errorMessage.value=null;
        if (!objEdicao.dtobraos) throw new Error('Informe data da ordem de serviço');
        if (!objEdicao.idobratpservico) throw new Error('Informe o serviço');
        if (!objEdicao.idbairro) throw new Error('Informe o bairro');
        isLoading.value = true;
        objEdicao.latitude   = !edLatitude.value ? 0 : parseFloat(edLatitude.value.toString().replace(',', '.')) || 0;
        objEdicao.longitude  = !edLongitude.value ? 0 : parseFloat(edLongitude.value.toString().replace(',', '.')) || 0;
        objEdicao.nmendereco = Funcoes.integerFromString(edNmEndereco.value);
        const response  = await genericPut('/cad/obras_os', objEdicao);
        if (response.bolok === 1){
            emit('salvo');
            emit('close');
        }else{
            errorMessage.value =`ATENÇÃO: ${response.erro}`;
        }
    } catch (error){errorMessage.value =`ATENÇÃO: ${error.message}`;
    } finally{isLoading.value=false;}
};

onMounted(lerDados);
</script>